module.exports = __webpack_public_path__ + "img/txt-collect.c8a02e10.png";